export enum Functions {
    Server = 0,
    Kitchen = 1,
    Dishwashing = 2,
}

export const getFunctionKeys = () => {
    return Object.keys(Functions).filter(key => isNaN(Number(key)));
}